export const bytesToMegabytes = (bytes) => (bytes / 1000000).toFixed(2) + 'MB'
